export const baseTranslationsDe = {
  "": "",
  app: "App",
  home: "Startseite",
  login: "Anmelden",
  addUser: "Benutzer hinzufügen",
  editUser: "Benutzer bearbeiten",
  logout: "Abmelden",
  user: "Benutzer",
  language: "Sprache",
  none: "Keine",
  role: "Rolle",
  roles: "Rollen",
  username: "Benutzername",
  email: "E-Mail",
  password: "Passwort",
  firstname: "Vorname",
  lastname: "Nachname",
  forgotPassword: "Passwort vergessen?",
  loginErrorTitle: "Login Fehler",
  userManagement: "Benutzerverwaltung",
  loginEmailError: "Für diesen Benutzernamen existiert kein Konto",
  loginPassword: "Falsches Passwort",
  loginError: "Falsche Zugangsdsaten",
  genericError:
    "Es ist ein Fehler aufgetreten, bitte versuchen sie es in ein paar Minuten erneut oder kontaktieren sie ihren Systemadministrator",
  search: "Suche",
  selectAll: "Alle auswählen",
  save: "Speichern",
  cancel: "Abbrechen",
  unchanged: "Unverändert",
  parameters: "Parameter",
  oneWeek: "Eine Woche",
  oneMonth: "Ein Monat",
  twoMonth: "Zwei Monate",
  threeMonth: "Drei Monate",
  sixMonth: "Sechs Monate",
  dragAndDopProperty:
    "Verwenden sie drag and drop auf einem Parameter um den Chart anzuzeigen",
  addFile: "Datei hinzufügen",
  name: "Name",
  type: "Typ",
  startDate: "Startdatum",
  endDate: "Enddatum",
  actions: "Aktionen",
  delete: "Löschen",
  deleted: "Gelöscht",
  confirmDelete: "Löschen bestätigen",
  error: "Fehler",
  status: "Status",
  page: "Seite",
  close: "Schließen",
  correlation: "Korrelation",
  covariance: "Kovarianz",
  selectedDateRange: "Ausgewählter Zeitraum",
  min: "Min",
  max: "Max",
  mean: "Schnitt",
  tendency: "Tendenz",
  offset: "Offset",
  months: "Monat | Monate",
  days: "Tag | Tage",
  hours: "Stunde | Stunden",
  minutes: "Minute | Minuten",
  seconds: "Sekunde | Sekunden",
  apply: "Anwenden",
  success: "Erfolgreich abgeschlossen",
  userCreated: "Der Benutzer wurde angelegt",
  changesSaved: "Die Änderungen wurden gespeichert",
  confirm: "Bestätigen",
  confirmDeleteUser:
    "Bitte bestätigen sie, dass sie den Benutzer {name} löschen wollen.",
  editAppSettings: "App Konfiguration",
  accessibleBy: "Verfügbar für:",
  discard: "Verwerfen",
  editAsset: "Anlage oder Gerät bearbeiten",
  creatingAssetTemplate: "Anlagen und Geräte - Vorlage wird erstellt",
  createTemplate: "Modell erstellen",
  create: "Erstellen",
  addField: "Feld hinzufügen",
  fields: "Felder",
  description: "Beschreibung",
  text: "Text",
  select: "Auswahl",
  number: "Zahl",
  createField: "Feld erstellen",
  selectionOptions: "Auswahlmöglichkeiten",
  editSelectionOptions: "Auswahlmöglichkeiten bearbeiten",
  createSelectionOptions: "Auswahlmöglichkeiten erstellen",
  options: "Optionen",
  add: "Hinzufügen",
  templateManagement: "Modellverwaltung",
  facetTransitions: "Übergänge",
  addFacetTransition: "Übergänge hinzufügen",
  sourceTemplate: "Quellvorlage",
  targetTemplate: "Zielvorlage",
  transition: "Übergang",
  transitionProperties: "Eigenschaften des Überganges",
  editableOnTransition: "Beim Übergang bearbeitbar",
  assets: "Anlagen und Geräte",
  showInTable: "Sichtbar in der Tabelle",
  createdAt: "Erstellt am",
  created: "Erstellt",
  lastEdit: "Zuletzt bearbeitet",
  saveAndCreateAnother: "Speichern und weiteren Eintrag erstellen",
  entryAdded: "Eintrag hinzugefügt",
  title: "Titel",
  link: "Link",
  image: "Bild",
  appsAdmin: "Apps verwalten",
  createApp: "App erstellen",
  defaultLanguage: "Standardsprache",
  translations: "Übersetzungen",
  translation: "Übersetzung",
  translationsSaved: "Übersetzungen wurden erfolgreich gespeichert.",
  translationEditingDisabled:
    "Ihre Sprache ({userLanguage}) unterscheidet sich von der Sprache des Twins ({twinLanguage}). Verwenden Sie Übersetzungen, um lokalisierte Texte zu bearbeiten.",
  propertyCreationLanguageWarning:
    "Ihre Sprache ({userLanguage}) unterscheidet sich von der Sprache des Twins ({twinLanguage}). Name und Beschreibung werden als {twinLanguage}-Übersetzungen gespeichert.",
  defaultTranslationsRequired: "Standardübersetzungen dürfen nicht leer sein.",
  noRoles: "Keine zugewiesenen Rollen",
  noTwinTemplatesExist: "Es wurden bisher keine Schablonen angelegt.",
  properties: "Felder",
  selectProperty: "Feld auswählen",
  addProperty: "Feld hinzufügen",
  refreshInterval: "Aktualisierungsintervall",
  assetManagement: "Anlagen und Geräte Management",
  yes: "Ja",
  no: "Nein",
  active: "Aktiv",
  noActiveVersion: "Keine aktive Version",
  hierarchy: "Hierarchie",
  back: "Zurück",
  changelog: "Änderungen",
  changelogDescription:
    "Änderungsprotokoll aller im Lager vorgenommener Ein- und Ausgänge.",
  changeType: "Änderungstyp",
  changedAt: "Geändert am",
  changedBy: "Geändert von",
  changedReason: "Änderungsgrund",
  assetCreated: "Anlage oder Gerät erstellt",
  propertyChanges: "Änderungen",
  id: "ID",
  reports: "Berichte",
  twinReportGroups: "Berichtsgruppen",
  twinReportSettings: "Berichtseinstellungen",
  twinReportSelectGroupFirst: "Bitte zuerst eine Gruppe auswählen",
  twinReportSettingSelect: "Einstellung auswählen",
  twinReportPrefix: "Typ Präfix",
  twinReportPropertyFilterCustomIds: "Filter Felder",
  twinReportReturnProperties: "Ergebnis Felder",
  twinReportId: "ID",
  twinReportModified: "Geändert am",
  twinReportFixedFilterValues: "Feste Filterwerte",
  twinReportValuesCommaSeparated: "Werte kommasepariert",
  twinReportSettingNameExplanation:
    "Eindeutiger interner Name für diese Berichtskonfiguration",
  twinReportLabelExplanation: "Name der Seite",
  twinReportTypeExplanation:
    "Definiert welche digitalen Zwillinge in diesem Bericht angezeigt werden. Entweder durch Auswahl einer Vorlage oder durch direkte Eingabe eines Typs.",
  twinReportFixedFiltersExplanation:
    "Diese Filter werden immer angewendet. Benutzer können sie nicht ändern.",
  twinReportUserFiltersExplanation:
    "Diese Filter werden Benutzern in der Berichtsansicht angezeigt um den Bericht weiter zu filtern.",
  twinReportColumnsExplanation:
    "Diese Spalten erscheinen in der Ergebnistabelle des Berichts.",
  twinReportSelectOrTypePrefixHint: "Vorlage wählen oder Typ-Präfix eingeben",
  assetReports: "Anlagen und Geräte Berichte",
  assetChangelog: "Anlagen und Geräte Änderungen",
  assetReportsDescription:
    "Übersicht der Anlagen und Geräte und deren detaillierte Dokumentation gruppiert pro Typ",
  assetChangelogReportsDescription:
    "Liste der Änderungen an Anlagen und Geräten für den ausgewählten Zeitraum",
  show: "Anzeigen",
  export: "Export",
  filter: "Filter",
  edit: "Bearbeiten",
  documents: "Dokumente",
  addImages: "Hier klicken oder per „Drag & Drop“ Bilder hinzufügen.",
  dropFilesHere: "Dateien hier ablegen",
  uploadDocument: "Dokument hinzufügen",
  file: "Datei",
  selectFile: "Datei wählen",
  noFileSelected: "Keine Datei ausgewählt",
  editDocument: "Dokument bearbeiten",
  assetType: "Typ",
  firstName: "Vorname",
  lastName: "Nachname",
  manageInputValues: "Eingabemöglichkeiten verwalten",
  inputValues: "Eingabemöglichkeiten",
  instances: "Instanzen",
  mandatory: "Pflichtfeld",
  relation: "Relation",
  selectMultiple: "Mehrfachauswahl",
  noValues: "Aktuell sind keine Werte angelegt",
  noData: "Keine Daten",
  followingFieldsAreRequired: "Die folgenden Felder müssen ausgefüllt werden:",
  fillInAllRequiredFields: "Bitte füllen Sie alle Pflichtfelder aus",
  addRelation: "Relation hinzufügen",
  relations: "Relationen",
  category: "Kategorie",
  changesStartDate: "Änderungen von",
  changesEndDate: "Änderungen bis",
  clickOnShowToViewData: "Klicken sie auf {0} um Daten anzuzeigen",
  results: "Ergebnisse",
  addItem: "{item} hinzufügen",
  editItem: "{item} bearbeiten",
  date: "Datum",
  year: "Jahr",
  yesNo: "Ja/Nein",
  pleaseEnterItem: "Bitte füllen sie das Feld '{item}' aus um fort zu fahren",
  itemAlreadyExists: "Ihre Eingabe existiert bereits",
  usedAsFilterIn: "Wird als filter verwendet für:",
  confirmDeleteValueList:
    "{valueList} wird als filter verwendet. Falls {valueList} gelöscht wird, werden die assoziierten Werte ebenfalls gelöscht.",
  selectFilterFirst: "Bitte wählen sie zuerst {filter} aus",
  propertyDeleteNotAvailableDueToFilteredValues:
    "{property} kann nicht gelöscht werden, da es als Filter für {filteredProperties} verwendet wird.\n\nErst wenn {property} nicht mehr als Filter verwendet wird kann es gelöscht werden.",
  spareParts: "Ersatzteile",
  settings: "Einstellungen",
  myAccount: "Mein Konto",
  myData: "Meine Daten",
  changePassword: "Passwort ändern",
  repeatPassword: "Passwort wiederholen",
  passwordChanged: "Passwort erfolgreich geändert.",
  passwordMinLength: "Das Password muss mindestens 8 Zeichen lang sein",
  passwordsDontMatch: "Die eingegebenen Passwörter stimmen nicht überein",
  articles: "Artikel",
  createArticle: "Artikel erstellen",
  singleArticles: "Einzelartikel",
  quantityArticle: "Mengenartikel",
  singleArticleDescription:
    "Artikel welche einzeln verwaltet werden. Z.B.: größere Ersatzteile für Maschinen.",
  quantityArticleDescription:
    "Artikel welche als Menge verwaltet werden, wie zum Beispiel Flüßigkeiten in Liter oder Schrauben in Kilogramm.",
  editable: "Bearbeitbar",

  handout: "Ausgabe",
  refill: "Eingang",
  transport: "Platzwechsel",
  inventory: "Inventur",

  amount: "Menge",
  comment: "Kommentar",
  warehouse: "Lager",
  components: "Bauteile",
  references: "Referenzen",
  handoutToUser: "Ausgeben an",
  storageLocation: "Lagerort",

  articleDocumentedCorrectly:
    "Artikel ist in richtiger Menge am dokumentierten Lagerort vorhanden",
  articleInventoryDifference: "Abweichender Bestand",
  actualInventory: "Festgestellter Bestand",
  reason: "Grund",
  articleDoesNotExist: "Artikel existiert nicht",
  groups: "Gruppen",
  group: "Gruppe",
  accessRights: "Berechtigungen",
  accessRightsWarehouse: "Lagerberechtigungen",
  createGroup: "Gruppe erstellen",
  targetAndSourceAreSame:
    "Der aktuelle Lagerort ist derselbe wie der Ziellagerort",
  systemMisconfigured:
    "Das System ist falsch konfiguriert, bitte wenden sie sich an den Systemadministrator",
  ticketViewMissingCustomIds: "Die Ticketansicht benötigt folgende Custom IDs:",
  editableOnCreate: "Bearbeitbar beim Erstellen",
  warehouseManager: "Lagermanager",
  warehouseInfo: "Lagerinfo",
  done: "Fertig",
  customId: "Custom id",
  all: "Alle",
  userCreatableEntriesForInputValues: "Dynamisches erstellen von Optionen",
  inventoryManagement: "Bestandsverwaltung",
  articleSearch: "Artikelsuche",
  addNomenclature: "Nomenklatur hinzufügen",
  createUser: "Benutzer erstellen",
  userExists:
    "Es existiert bereits ein Nutzer mit dieser E-Mail oder diesem Benutzernamen",

  // Ticket management
  myTickets: "Meine Tickets",
  ticketsAssignedToMe: "Mir zugewiesene Tickets",
  priority: "Priorität",
  plannedFinish: "Geplante Fertigstellung",
  firstPlannedFinish: "Erste geplante Fertigstellung",
  createdBy: "Erstellt von",
  assignee: "Zugewiesen an",
  comments: "Kommentare",
  send: "Absenden",
  low: "Niedrig",
  medium: "Medium",
  high: "Hoch",
  loadPreviousComments: "Vorherige Kommentare laden",
  createTicket: "Ticket erstellen",
  files: "Dateien",
  noFiles: "Keine Dateien",
  noRelations: "Keine Relationen",
  requester: "Antragsteller",
  takeInProcess: "In Bearbeitung nehmen",
  reject: "Ablehnen",
  complete: "Abschliessen",
  validate: "Bestätigen",
  invalidate: "Ablehnen",
  longComment: "Details",
  draft: "Entwurf",
  createDraft: "Entwurf erstellen",
  submitDraft: "Entwurf einreichen",
  submit: "Einreichen",
  rejected: "Abgelehnt",
  new: "Neu",
  // Unfortunately the backend uses whitespace naming here
  "in process": "In Bearbeitung",
  completed: "Abgeschlossen",
  notCompleted: "Nicht abgeschlossen",
  confirmed: "Bestätigt",
  plan: "Planen",
  planned: "Geplant",
  reopen: "Wiedereinreichen",
  myRequests: "Meine Anfragen",
  assignedToMe: "Mir Zugewiesen",
  assetManager: "Anlagen und Geräte manager",
  assetInfo: "Anlagen und Geräte info",
  maintenance: "Wartung",
  asset: "Anlagen und Geräte",
  location: "Ort",
  assetOrLocation: "Anlagen und Geräte oder ort",
  reportedBy: "Gemeldet von",
  damageDescription: "Schadensbeschreibung/-ursache",
  workCarriedOut: "Durchgeführte Arbeiten",
  ticketAdmin: "Ticketabwicklung",
  sopManagement: "Arbeitsanweisungsmanagement",
  enterWorkCarriedOutBeforeCompleting:
    "Bitte geben sie durchgeführte Arbeiten ein um das Ticket ab zu schließen.",
  enterWorkDurationBeforeCompleting:
    "Bitte geben sie die Arbeitsdauer ein um das Ticket ab zu schließen.",
  createPlan: "Neuer Plan",
  repetition: "Wiederholung",
  weeks: "Woche |Wochen",
  years: "Jahr | Jahre",
  createMaintenancePlan: "Wartungsplan erstellen",
  editMaintenancePlan: "Wartungsplan bearbeiten",
  selectAsset: "Anlage oder Gerät auswählen",
  selectAtLeastOneAsset:
    "Wählen Sie mindestens eine Anlage oder ein Gerät aus.",
  ticketCreationMode: "Ticketerstellung",
  ticketPerAsset: "Pro Anlage und Gerät ein Ticket erstellen",
  ticketForAllAssets: "Ein Ticket für alle Anlagen und Geräte erstellen",
  leadDuration: "Vorlaufzeit",
  createSop: "Neue Arbeitsanweisungen",
  sop: "Arbeitsanweisungen",
  maintenancePlans: "Wartungspläne",
  maintenancePlan: "Wartungsplan",
  timespan: "Zeitspanne",
  firstActivation: "Erste Aktivierung",
  leadDurationDescription:
    "Die Zeit zwischen dem Erstellen des Tickets und der geplanten Fertigstellung. Falls zum Beispiel die Vorlaufzeit 1 Monat beträgt, wird das Ticket zu dieser Wartung 1 Monat vor dem Fälligkeitsdatum erstellt.",
  ticketName: "Ticketname",
  ticketDescription: "Ticketbeschreibung",
  confirmDeleteMaintenancePlan:
    "Bitte bestätigen sie, dass sie den Wartungsplan {name} löschen möchten.",
  addSop: "Arbeitsanweisungen hinzufügen",
  addChecklist: "Checkliste hinzufügen",
  checklistName: "Name der Checkliste",
  addEntry: "Eintrag hinzufügen",
  checklist: "Checkliste",
  createTicketForTask: "Ticket für diese Aufgabe erstellen",
  ticketTemplate: "Ticketvorlage",
  transferToTicket: "In Ticket übertragen",
  sops: "Arbeitsanweisungen",
  tasks: "Aufgaben",
  addMaterial: "Material hinzufügen",
  materialUse: "Materialverwendung",
  feedback: "Rückmeldung",
  completeTodoListItem: "Anweisung abschließen",
  itemsAvailable: "{items} verfügbar",
  createSopVersion: "Version erstellen",
  manageSopVersions: "Arbeitsanweisungs-Versionen verwalten",
  firstActivatedAt: "Erste Aktivierung",
  activation: "Aktivierung",
  confirmActivateVersion:
    "Sind sie sich sicher, dass sie die Version {1} {0} wollen?",
  activateSopVersion: "Arbeitsanweisungs-Version aktivieren",
  deactivateSopVersion: "Arbeitsanweisungs-Version deaktivieren",
  activate: "Aktivieren",
  deactivate: "Deaktivieren",
  activateAll: "Alle aktivieren",
  deactivateAll: "Alle deaktivieren",
  editSop: "Arbeitsanweisungen {name} bearbeiten",
  createTask: "Aufgabe erstellen",
  completionTracking: "Abschlussverfolgung",
  tasklist: "Aufgabenliste",
  task: "Aufgabe",
  sopNotEditable:
    "Diese Arbeitsanweisungen sind nicht editierbar, da sie bereits verwendet wurden. Um die Arbeitsanweisungen zu überarbeiten muss einen neue Version erstellt werden.",
  editTask: "Anweisung bearbeiten",
  version: "Version",
  versionActivated: "Version aktiviert",
  versionDeactivated: "Version deaktiviert",
  nOfMTasksCompleted: "({n}/{m}) Aufgaben erledigt",
  Permission: "Berechtigung",
  Permissions: "Berechtigungen",
  UniqueID: "Identifier",
  Accesstype: "Zugriffstyp",
  readAccess: "lesen",
  writeAccess: "schreiben",
  chooseDifferentArticle: "einen anderen Artikel auswählen",
  removeArticleFromWarehouse: "Diesen Artikel aus dem Lager entfernen",
  errorRemovingArticleFromWarehouse:
    "Der Artikel konnte nicht aus dem Lager entfernt werden, bitte navigieren sie zur Lagerverwaltung und dokumentieren sie dort den Warenausgang.",
  damageNotice: "Schadensmeldung",
  ticketType: "Ticketart",
  ticketNumber: "Ticket Nr.",
  qmdocuments: "Qualitätssicherungsvereinbarungsdokumente",
  customer: "Kunde",
  addDocument: "Dokument hinzufügen",
  inProcess: "In Bearbeitung",
  atCustomer: "Beim Kunden",
  finished: "Abgeschlossen",
  accepted: "Akzeptiert",
  content: "Inhalt",
  proposal: "Inhaltsvorschlag",
  dataSources: "Datenquellen",
  accept: "Akzeptieren",
  rewrite: "Umformulieren",
  filename: "Dateiname",
  itAssets: "IT Geräte",
  itAssetChangelog: "IT Geräte Änderungen",
  inspection: "Inspektion",
  itAssetManager: "IT Geräte Manager",
  itAssetInfo: "IT Geräte Informationen",
  maintenancePlanNotEditable:
    "Dieser Wartungsplan ist nicht editierbar, da er zur Zeit aktiv ist.",
  upload: "Upload",
  downloadTemplate: "Vorlage herunterladen",
  uploadCompleted: "Upload erfolgreich",
  csvUploadValuesMustMatchTemplate:
    "Die Werteliste muss der herunterladbaren Vorlage entsprechen.",
  csvUploadSeparatorMustBeSemicolon:
    "Das Trennzeichen muss ein Semikolon (;) sein.",
  csvUploadEncodingMustBeUtf8:
    "Die CSV-Datei muss als reines UTF-8 kodiert sein.",
  csvUploadMustNotEndWithEmptyLine:
    "Die CSV-Datei darf keine abschließende Leerzeile enthalten.",
  csvUploadSemicolonValuesMustBeQuoted:
    'Werte mit einem Semikolon (;) müssen in Anführungszeichen stehen, zum Beispiel "G 1 T 37;1".',
  maintenancePlanStartDateHasToBeInTheFutureToActivate:
    "Das Fälligkeitsdatum muss in der Zukunft liegen um den Plan zu aktivieren.",
  paragraphs: "Paragraphen",
  addParagraph: "Paragraph hinzufügen",
  processing: "Wird verarbeitet...",
  proposedContent: "Vorgeschlagener Inhalt",
  sentenceDetails: "Details",
  decline: "Ablehnen",
  addCustomContentProposal: "Eigenen Vorschlag einfügen",
  addContentAndAccept: "Vorschlag einfügen",
  useProposedContent: "Inhaltsvorschlag übernehmen",

  groupManagement: "Gruppenverwaltung",
  permissions: "Berechtigungen",
  permission: "Berechtigung",
  appRoles: "Anwendungsrollen",
  label: "Label",
  path: "Pfad",
  protocol: "Protokoll",
  selection: "Auswahl",
  addPermission: "Berechtigung hinzufügen",
  clientId: "Client ID",
  howSatisfiedAreYouWithTheProposal:
    "Wie zufrieden sind sie mit dem Vorschlag?",
  unsatisfied: "Sehr Unzufrieden",
  notSatisfied: "Unzufrieden",
  mostlySatisfied: "Einigermaßen zufrieden",
  satisfied: "Zufrieden",
  verySatisfied: "Sehr zufrieden",
  editParagraph: "Paragraph bearbeiten",
  editParagraphWarning:
    "Wenn der Paragraph komplett überarbeitet wird gehen alle aktuellen Änderungen an einzelnen Sätzen verloren.",
  addRoles: "Anwendungsrollen hinzufügen",
  addCustomerResponse: "Antwort des Kunden einpflegen",
  editedVersion: "Überarbeitetete Version",
  similarSnippets: "Ähnliche Abschnitte",
  suggestion: "Empfehlung",
  document: "Dokument",
  customerResponse: "Antwort des Kunden",
  declined: "Abgelehnt",
  confirmDeleteItem: "Bitte bestätigen sie, dass sie {item} löschen wollen.",
  noSuggestion: "Kein Vorschlag",
  categories: "Kategorien",
  DE: "Deutsch",
  EN: "Englisch",
  createTranslation: "Übersetzung hinzufügen",
  createTopic: "Thema hinzufügen",
  editCategoryName: "Kategorie {name} bearbeiten",
  default: "Standard",
  topic: "Thema",
  categoryIsAlreadyInUse:
    "Die Kategorie kann nicht gelöscht werden, da sie bereits verwendet wird",
  warehouseTransfer: "Lagerwechsel",
  constraint: "Einschränkung",
  single: "Einfach",
  multiple: "Mehrfach",
  template: "Vorlage",
  calendar: "Kalender",
  duration: "Dauer",
  workDuration: "Arbeitsdauer",
  cloneTemplate: "Modell klonen",
  confirmCloneTemplate:
    "Sind sie sicher dass sie das Modell {name} klonen möchten?",
  ticketSearch: "Ticketsuche",
  onlyImagesAreAllowed: "Der Upload ist auf Bilder beschränkt",
  errorUpdatingPassword: "Das Passwort konnte nicht geändert werden.",
  technicalSpecificationsAndEquipmentEngineeringDocuments:
    "Technische Spezifikationen und Unterlagen zur Ausrüstung",
  equipmentLifecycleDocumentationAndMaintenanceRecords: "Wartungsdokumentation",
  moveToName: "Nach {name} verschieben",
  refresh: "Aktualisieren",
  responsibility: "Zuständigkeit",
  causeCategory: "Ursachenkategorie",

  saveMultipleInstances: "Mehrere Instanzen erstellen",
  chooseAmountOfInstances:
    "Wählen sie die Menge der Instanzen die erstellt werden sollen ",
  nOfmInstancesCreated: "{n} von {m} Instanzen erstellt",
  machineRestrictions: "Gerätebeschränkungen",
  install: "Installieren",
  field: "Feld",
  value: "Wert",
  visible: "Sichtbar",
  editProperty: "Feld bearbeiten",
  machineRestrictionCreateDialogDescription:
    "Gerätebeschränkungen erlauben es die Eingabemöglichkeiten für Vorlagen auf einem Gerät einzuschränken. Bitte wählen sie die Vorlage für welche die Eingabemöglichkeit beschränkt werden soll.",
  hidden: "Versteckt",
  locked: "Gesperrt",
  editMachineRestrictionName: "Gerätebeschränkung {name} bearbeiten",
  createMachineRestriction: "Gerätebeschränkung erstellen",
  installedOnTheDevice: "Auf diesem Gerät installiert",
  uninstall: "Deinstallieren",
  replaceMachineRestriction: "Gerätebeschränkung ersetzen",
  replaceMachineRestrictionDetails:
    "Die installation der Gerätebeschränkung {newName} würde die existierende Gerätebeschränkung {oldName} überschreiben.",
  german: "Deutsch",
  english: "Englisch",
  spanish: "Spanisch",
  qrCodeOutdated: "Dieser QR Code ist nicht mehr aktiv",
  sopActivationExplanation:
    "Durch die Aktivierung einer Arbeitsanweisungs-Version wird der Inhalt dieser Version fixiert. Sie kann nicht mehr bearbeitet werden. Bei erforderlichen Änderungen muss eine neue Version erstellt werden. In der Konfiguration von Wartungsplänen können nur aktive Versionen ausgewählt werden.",
  interventionPeriod: "Interventionszeitraum",
  images: "Bilder",
  noImages: "Keine Bilder",
  notFound: "Die aufgerufene Seite existiert nicht",
  accessDenied: "Fehlende Zugriffsrechte",
  apps: "Anwendungen",
  dashboard: "Dashboard",
  dashboards: "Dashboards",
  dashboardsComingSoon: "Dashboards werden in Kürze verfügbar sein.",
  assetDashboard: "Anlagen-Dashboard",
  availability: "Verfügbarkeit",
  mtbf: "MTBF",
  mtbfLong: "Mean Time Between Failures",
  mttr: "MTTR",
  mttrLong: "Mean Time To Repair",
  maintenanceRatio: "Wartungsverhältnis",
  preventive: "Präventiv",
  corrective: "Korrektiv",
  spindleTemperature: "Spindeltemperatur",
  vibration: "Vibration",
  powerConsumption: "Leistungsaufnahme",
  last7Days: "Letzten 7 Tage",
  warningThreshold: "Warnung",
  limitThreshold: "Grenzwert",
  hybridProductionTitle: "Hybride Produktions- & Finanzkennzahlen",
  liveTelemetrySapCo: "Live-Telemetrie & SAP CO",
  oeeFinancialized: "OEE (Finanzialisiert)",
  oeeDescription:
    "Kombiniert Verfügbarkeit, Leistung und Qualität. Direkte Verknüpfung zu nicht gedeckten Gemeinkosten.",
  optimalRuntime: "Optimale Laufzeit",
  optimalRuntimeDescription:
    "Anteil der Betriebszeit bei theoretischer Maximalzykluszeit. Rückgänge deuten auf Margenverluste hin.",
  throughputPpm: "Durchsatz (PPM)",
  throughputDescription:
    "Teile pro Minute. Hohe Geschwindigkeit reduziert direkt die fixen Herstellkosten pro Einheit.",
  firstPassYield: "Erstdurchlaufquote (FPY)",
  firstPassYieldDescription:
    "Qualitätskennzahl. Hohe FPY eliminiert Ausschusskosten und Nacharbeitsaufwand.",
  maintenanceCostPerUnit: "IH-Kosten pro Einheit",
  maintenanceCostDescription:
    "Die operative Kernkennzahl. Direkt aus dem SAP Universal Journal bezogen.",
  maintenanceCostRatio: "IK / WBW",
  maintenanceCostRatioDescription:
    "Instandhaltungskosten vs. geschätzter Wiederbeschaffungswert. Rechtfertigt neue CapEx gegenüber Reparaturen.",
  mtbfDescription:
    "Mittlere Betriebsdauer zwischen Ausfällen. Planbarkeit sichert die Einhaltung von Produktionsplänen.",
  preventiveCompliance: "Präventive Einhaltung",
  preventiveComplianceDescription:
    "Frühindikator. Hohe Einhaltung korreliert stark mit null katastrophalen Ausfällen.",
  perMinute: "/ Min",
  hoursUnit: "Std",
  addDashboard: "Dashboard hinzufügen",
  noDashboardsYet: "Noch keine Dashboards",
  noDashboardsYetDescription:
    "Erstellen Sie Ihr erstes Dashboard, um Daten zu visualisieren und zu überwachen.",
  createFirstDashboard: "Erstes Dashboard erstellen",
  dashboardTitle: "Dashboard Titel",
  dashboardCreated: "Dashboard erfolgreich erstellt",
  dashboardSettingsSaved: "Dashboard-Einstellungen gespeichert",
  failedToLoadDashboard: "Dashboard konnte nicht geladen werden",
  failedToSaveSettings: "Einstellungen konnten nicht gespeichert werden",
  noDashboardItems: "Keine Dashboard-Elemente vorhanden",
  addDashboardItem: "Dashboard-Element hinzufügen",
  selectItemTypePrompt:
    "Wählen Sie den Typ des Elements, das Sie hinzufügen möchten:",
  twinTextOverview: "Twin Übersicht",
  twinTextOverviewDescription: "Eigenschaften eines Twins als Text anzeigen",
  richText: "Text",
  richTextDescription: "Statischen Text anzeigen",
  richTextContentPlaceholder: "Text eingeben...",
  textSize: "Textgröße",
  textColor: "Textfarbe",
  backgroundColor: "Hintergrundfarbe",
  imageDashboardItem: "Bild",
  imageDashboardItemDescription: "Hochgeladenes Bild anzeigen",
  selectImage: "Bild auswählen",
  replaceImage: "Bild ersetzen",
  imageUnavailable: "Kein Bild ausgewählt",
  objectFit: "Bildanpassung",
  objectFitContain: "Einpassen",
  objectFitCover: "Ausfüllen",
  failedToDeleteImageDocument: "Bilddokument konnte nicht gelöscht werden",
  dqKpiPercentage: "KPI Prozentsatz",
  dqKpiPercentageDescription:
    "Datensatz-Auffälligkeiten als Prozentsatz anzeigen",
  dqKpiTotal: "KPI Gesamt",
  dqKpiTotalDescription: "Datensatz-Auffälligkeiten als Gesamtanzahl anzeigen",
  dqAnomalousEntries: "Anomale Einträge",
  dqAnomalousEntriesDescription:
    "Anomale Einträge für ein Datenbankfeld anzeigen",
  itemCreatedSuccessfully: "Element erfolgreich erstellt",
  failedToCreateItem: "Element konnte nicht erstellt werden",
  itemDeletedSuccessfully: "Element erfolgreich gelöscht",
  failedToDeleteItem: "Element konnte nicht gelöscht werden",
  itemUpdatedSuccessfully: "Element erfolgreich aktualisiert",
  failedToUpdateItem: "Element konnte nicht aktualisiert werden",
  deleteItem: "Element löschen",
  failedToSaveLayoutChanges:
    "Layout-Änderungen konnten nicht gespeichert werden",
  gridSize: "Spalten × Zeilen",
  gridMargin: "Abstand X × Y",
  gridMinSize: "Mindestgröße B × H",
  fixedSize: "Breite × Höhe",
  marginX: "Abstand X",
  marginY: "Abstand Y",
  minWidth: "Mindestbreite",
  minHeight: "Mindesthöhe",
  fixedWidth: "Feste Breite",
  fixedHeight: "Feste Höhe",
  selectPurpose: "Zweck auswählen",
  dataQuality: "Datenqualität",
  maintenanceOverview: "Wartungsübersicht",
  tmAggregateBarChart: "Ticket-Aggregation",
  tmAggregateBarChartDescription: "Balkendiagramm nach Ticket-Eigenschaft",
  tmTimeAggregateBarChart: "Ticket-Zeitverlauf",
  tmTimeAggregateBarChartDescription: "Ticketanzahl über Zeitbereiche",
  aggregationProperty: "Gruppieren nach",
  statusTransitionValue: "Status",
  statusTransitionMode: "Modus",
  bucketSize: "Intervall",
  addFilter: "Filter hinzufügen",
  filters: "Filter",
  fixedFilters: "Filter",
  filterCustomId: "Eigenschaft",
  filterValues: "Werte",
  current: "Aktuell",
  transitioned: "Übergegangen",
  quarter: "Quartal",
  week: "Woche",
  timeframe: "Zeitraum",
  lastWeek: "Letzte Woche",
  lastMonth: "Letzter Monat",
  lastQuarter: "Letztes Quartal",
  lastYear: "Letztes Jahr",
  timeframeLast12Months: "Letzte 12 Monate",
  timeframeLastQuarter: "Letztes Quartal",
  timeframeLast30Days: "Letzte 30 Tage",
  timeframeLast7Days: "Letzte 7 Tage",
  timeframeYearToDate: "Jahr bis heute",
  timeframePreviousYear: "Letztes Jahr",
  bucketQuarter: "Quartal",
  bucketMonth: "Monat",
  bucketWeek: "Woche",
  bucketDay: "Tag",
  chartLoadError: "Diagramm konnte nicht geladen werden",
  general: "Allgemein",
  deleteDashboard: "Dashboard löschen",
  confirmDeleteDashboard:
    "Möchten Sie dieses Dashboard wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
  dashboardDeleted: "Dashboard erfolgreich gelöscht",
  failedToDeleteDashboard: "Dashboard konnte nicht gelöscht werden",
  layoutSettings: "Layout Einstellungen",
  sizeMode: "Größenmodus",
  fullWidth: "Volle Breite",
  fullHeight: "Volle Höhe",
  auto: "Automatisch",
  fixed: "Fix",
  scroll: "Scrollen",
  kiosk: "Kiosk / Vollbild",
  layoutMode: "Layout-Modus",
  gridRowHeight: "Zeilenhöhe (px)",
  verticalCompact: "Vertikal komprimieren",
  fitContentToContainer: "Inhalt an Container anpassen",
  sizeModeScrollDescription: "Feste Zeilenhöhe, Inhalt scrollt nach unten.",
  sizeModeFullWidthDescription:
    "Füllt immer die volle Viewport-Breite aus, scrollt vertikal.",
  sizeModeFullHeightDescription:
    "Passt sich exakt an die Bildschirmhöhe an – ideal für Wanddisplays und Kiosk-Screens.",
  sizeModeFixedDescription: "Exakte Pixel-Abmessungen für Breite und Höhe.",
  thisUserHasNoApps: "Für diesen Nutzer wurden keine Anwendungen eingerichtet",
  notifications: "Benachrichtigungen",
  notification: "Benachrichtigung",
  addSubscription: "Abonnement hinzufügen",
  subscribers: "Abonnenten",
  subscriptionAdded: "Abonnement hinzugefügt",
  subscriptionRemoved: "Abonnement entfernt",
  subscriptionUpdated: "Subscription geändert",
  noEventsInThisApp: "Diese App hat keine Benachrichtigungen",
  groupAlreadySubscribed: "Diese Gruppe hat bereits ein Abonnement",
  subscribe: "Abonnieren",
  currentlyNoSubscriptions:
    "Diese Benachrichtigung hat noch keine Abonnements. Klicken sie auf {0} um ein Abonnement hinzuzufügen.",
  contacts: "Kontakte",

  countryCode: "Landesvorwahl",
  phoneNumber: "Telefonnummer",
  street: "Straße",
  numberShort: "Nr.",
  areaCode: "Postleitzahl",
  city: "Stadt",
  country: "Land",
  address: "Adresse",

  addEmail: "E-mail hinzufügen",
  addAddress: "Adresse hinzufügen",
  addPhone: "Telefnonummer hinzufügen",
  userAlreadySubscribed: "Dieser Nutzer hat bereits ein Abonnement",
  subscriptions: "Abonnements",
  lastModified: "Zuletzt bearbeitet",
  lastModifiedBy: "Zuletzt bearbeitet von",
  ticketsCreatedByThisPlan: "Durch diesen Plan erstellte Tickets",
  contributors: "Mitarbeitende",
  contributing: "Mitarbeitend",
  andNMore: "+{n} weitere",
  endEdit: "Bearbeiten beenden",
  addContact: "Kontakt hinzufügen",
  company: "Unternehmen",
  person: "Person",
  attachments: "Anhänge",
  editSubscription: "Abonnement bearbeiten",
  registrationNumber: "Registrierungsnummer",
  vatId: "Steuernummer",
  userInformation: "Benutzerdaten",
  plannedFinishDescription:
    "Geplantes ende der ersten Wartung. Das Datum wird im Kalender als ende der ersten Wartung verwendet. Zukünftige tickets werden nach dem ersten geplanten Fertigstellungsdatum immer nach {repetition} erstellt.",
  plannedStart: "Geplanter Start",
  plannedDuration: "Geplanter Zeitraum",
  to: "bis",
  ticketHistory: "Tickethistorie",
  newComment: "Neuer Kommentar",
  editedBy: "Bearbeitet von",
  deletedBy: "Gelöscht von",
  changedTo: "geändert zu",

  hasAddedrelationToValue: "hat eine Relation zu {value} hinzugefügt",
  hasDeletedRelationToValue: "hat eine Relation zu {value} gelöscht",
  hasAddedDocumentName: "hat das Dokument {name} hinzugefügt",
  hasDeletedDocumentName: "hat das Dokument {name} gelöscht",
  hasAddedImage: "hat ein Bild hinzugefügt",
  hasDeletedImage: "hat ein Bild gelöscht",

  oee: "OEE",
  outdatedVersionReloadPage:
    "Diese Version ist veraltet. Klicken sie hier um die Seite neu zu laden.",
  confirmRemoveUserFromGroup:
    "Sind sie sich sicher dass sie diesen Benutzer aus der Gruppe {name} entfernen wollen?",
  addGroup: "Gruppe hinzufügen",

  hasAddedSopName: "hat die Arbeitsanweisungen {name} hinzugefügt",
  hasDeletedSopName: "hat die Arbeitsanweisungen {name} entfernt",
  hasAddedSopInstanceName:
    "hat eine Arbeitsanweisungsinstanz {name} hinzugefügt",
  hasDeletedSopInstanceName:
    "hat eine Arbeitsanweisungsinstanz {name} entfernt",
  hasAddedTasklistName: "hat die Aufgabenliste {name} hinzugefügt",
  hasDeletedTasklistName: "hat die Aufgabenliste {name} entfernt",
  hasUpdatedTasklistName: "hat die Aufgabenliste {name} aktualisiert",
  hasAddedTasklistItemIn: "hat ein Element in {name} hinzugefügt",
  hasAddedTasklistItemsIn:
    "hat {count} Elemente zur Taskliste {name} hinzugefügt",
  hasDeletedTasklistItemIn: "hat ein Element in {name} entfernt",
  hasUpdatedTasklistItemIn: "hat ein Element in {name} aktualisiert",

  commentUpdated: "Kommentar bearbeitet",
  commentDeleted: "Kommentar gelöscht",

  editOriginal: "Original überarbeiten",
  contactCreatedButCompanyRelationNotCreated:
    "Der Kontakt wurde erstellt aber er konnte nicht zu einem Unternehmen zugeordnet werden. Bitte versuchen sie erneut den Kontakt dem Unternehmen zu zu ordnen.",
  addCompany: "Unternehmen hinzufügen",
  hasSetNameToValue: "hat {name} auf {value} gesetzt",
  hasChangedNameFromOldValueToNewValue:
    "hat {name} von {oldValue} auf {newValue} geändert",
  removed: "entfernt",
  hasAddedMaterialComsumptionName:
    "hat {name} als Materialverwendung eingetragen",
  thisTwinHasNoLifecycleData:
    "Für dieses Objekt existiert keine Historie. Dies ist der Fall für Objekte welche vor März 2025 erstellt wurden.",
  changelogs: "Änderungen",
  addDocuments: "Dokumente hinzufügen",
  knowledgeSpaces: "Wissensräume",
  addKnowledgeSpace: "Wissensraum hinzufügen",
  users: "Benutzer",
  knowledgeDocuments: "Wissensdokumente",
  confirmYouWantToRemoveNameFromSpace:
    "Bitte bestätigen sie, dass sie {name} von {space} entfernen möchten",
  addFilesDialogHelper:
    "Verwenden sie die Ablagefläche um entweder durch klicken oder durch Drag & Drop Dateien hinzuzufügen. Die Dateien werden erst nach einem Klick auf Upload hoch geladen.",
  documentsAlreadyInList:
    "Die folgenden Dokumente wurden nicht hinzugefügt, da sie bereits in der Liste sind: {names}",
  targetUnitRequiredForFiles:
    "Für die folgenden Dateien muss ein Wissensbaustein ausgewählt werden: {names}",
  duplicateNewVersionOfTarget:
    "Der folgende Wissensbaustein wurde mehrfach als Ziel für 'Neue Version von' ausgewählt: {names}",
  namelessDocument: "Namenloses Dokument",
  chats: "Konversationen",
  addChat: "Eine Frage stellen",
  moreOptions: "Weitere Optionen",
  dateRange: "Zeitraum",
  typeAMessage: "Geben sie eine Frage ein...",
  knowledgeSpace: "Wissensraum | Wissensräume",
  question: "Frage",
  chat: "Chat",
  knowledgeUnits: "Wissensdatenbank",
  startNewChat: "Neue Konversation starten",
  errorLoadingMessages:
    "Fehler beim laden vorheriger Nachrichten. Sie können trotzdem weitere Fragen stellen.",
  summary: "Zusammenfassung",
  member: "Mitglied",
  steward: "Verwaltung",
  owner: "Besitzer",
  manageKnowledgeUnits: "Wissensbausteine verwalten",
  addKnowledgeUnit: "Wissensbaustein hinzufügen",
  withRole: "mit Rolle",
  uploadDocuments: "Dokumente hochladen",
  accessToKnowledgeSpaceRevoked:
    "Der Zugriff auf den Wissensraum wurde verweigert",
  noChats: "Keine Konversationen vorhanden",
  noConversations: "Keine Konversationen",
  noConversationsFound: "Keine Konversationen gefunden",
  archived: "Archiviert",
  open: "Öffnen",
  turns: "{count} Gesprächsbeiträge",
  lastActivity: "Letzte Aktivität: {date}",
  confirmRemoveDocumentFromSpace:
    "Sicher dass dieses Dokument aus dem Raum entfernt werden soll? Das Dokument bleibt nach dem entfernen in anderen Räumen weiterhin verfügbar.",
  remove: "Entfernen",
  textOptions: "Text optionen",

  maxLength: "Maximale länge",
  multiLine: "Mehrzeilig",
  singleLine: "Einzeilig",
  rows: "Zeilen",
  aiSearchable: "Sichtbar für KI",
  clickOrDropHere: "Hier klicken oder eine Datei ablegen",
  knowledgeUnitsUsedForReply: "Für die Antwort verwendete Wissensbausteine",
  changesSavedSuccessfully: "Änderungen erfolgreich gespeichert",
  thinking: "Denke nach...",
  confirmRemoveKnowledgeSpace:
    "Sicher dass sie den Wissensraum {spaceName} entfernen möchten?",
  createNewKnowledgeUnit: "Neuen Wissensbaustein erstellen",
  newVersionOf: "Neue Version von",
  referenceFor: "Referenz für",
  detectingSimilarUnit: "Ähnliche Einheit wird erkannt...",
  targetKnowledgeUnit: "Wissensbaustein",
  addExistingKnowledgeUnit: "Existierenden Wissensbaustein hinzufügen",
  addUnitsDialogHelp: `Dieser Dialog ermöglicht es, bestehende Wissensbausteine zum aktuellen Wissensraum hinzuzufügen oder daraus zu entfernen.
    Es werden alle Bausteine angezeigt, auf die ein Zugriff besteht. Über den Schalter auf der rechten Seite können Sie einen Baustein hinzufügen oder entfernen.`,
  addUnitsDialogHelpExample:
    "Dies kann verwendet werden um häufig verwendete Dokumente wie unternehmensweite Richtlinien oder Handbücher in mehreren Wissensräumen verfügbar zu machen und diese zentral zu pflegen.",
  editKnowledgeUnits: "Wissensbausteine bearbeiten",
  thoughts: "Gedanken",
  available: "Verfügbar",
  addNewVersion: "Neue version hinzufügen",
  onlyDocumentsWithStatusDoneCanBeActivated:
    "Diese Version kann nicht aktiviert werden da sie nicht verarbeitet wurde",
  documentDetails: "Dokument",
  versions: "Versionen",
  thisChatIsBasedOnOutDatedInformation:
    "Diese Konversation basiert auf veralteten Wissensbausteinen. Es können keine weiteren Fragen gestellt werden.",
  details: "Details",
  section: "Abschnitt",
  errorLoadingSuggestedQuestions:
    "Es gab einen Fehler beim Laden der vorgeschlagenen Fragen",
  suggestedQuestions: "Vorgeschlagene Fragen",
  addQuestion: "Frage hinzufügen",
  testThisQuestion: "Frage testweise stellen",
  editQuestion: "Frage bearbeiten",
  createName: "{name} erstellen",
  newEntry: "Neuer Eintrag",
  uploadImage: "Bild hochladen",
  documentUploadedSuccessMessage: "Dokument erfolgreich hochgeladen",
  inactive: "Inaktiv",
  automaticCorrection: "Automatische korrektur",
  generatingCorrection: "Generiere Korrektur",
  automaticServicesUnavailable: "Automatische Services nicht erreichbar",
  automaticCorrectionRestart: "Autokorrekturfehler, klicken um neu zu starten",
  automaticCorrectionAvailable: "Autokorrektur verfügbar",
  deleteCorrection: "Autokorrektur löschen",
  saveAutoCorrection: "Autokorrekur anwenden",
  versionManagement: "Versionsverwaltung",
  retry: "Erneut versuchen",
  versionNameActivatedClickHereToViewThisVersion:
    "Version {name} aktiviert. Klicken sie hier um diese Version zu bearbeiten.",
  deleteSuccess: "Erfolgreich entfernt",
  exportStarted: "Export gestartet",
  exportStartedDescription:
    "Der Export wird vorbereitet. Dies kann etwas dauern.",
  maintenanceReports: "Wartungstickets",
  reportsOverview: "Berichtsübersicht",
  confirmRemoveKnowledgeUnit:
    "Sind sie sich sicher, dass sie den Wissensbaustein {name} entfernen möchten?",
  knowledgeUnitCantBeDeletedBecauseItHasBeenActivated:
    "Der Wissensbaustein kann nicht entfernt werden, da er bereits aktiviert wurde.",
  databases: "Datenbanken",
  updated: "Aktualisiert",
  records: "Einträge",
  good: "Gut",
  warning: "Warnung",
  critical: "Kritisch",
  connected: "Verbunden",
  tables: "Tabellen",
  tickets: "Tickets",
  completeness: "Vollständigkeit",
  accuracy: "Genauigkeit",
  consistency: "Konsistenz",
  validity: "Validität",
  score: "Score",
  method: "Methode",
  scope: "Scope",
  llmSearchableWarningMessage:
    "Die Sichtbarkeit für KI wurde aktiviert, beachten Sie, dass es einige Zeit dauern kann, bis die vorhandenen Felder verarbeitet und sichtbar sind.",
  databaseManagement: "Datenbankverwaltung",
  filePreviewNotSupportedByYourBrowser:
    "Die Vorschau dieser Datei wird von Ihrem Browser nicht unterstützt.",
  databaseConnectionCreated: "Datenbankverbindung erstellt",
  databaseConnectionUpdated: "Datenbankverbindung aktualisiert",
  databaseConnectionDeleted: "Datenbankverbindung gelöscht",
  databaseConnectionError: "Fehler bei der Erstellung der Datenbankverbindung",
  databaseConnectionTested: "Datenbankverbindung erfolgreich getestet",
  createDatabaseConnection: "Datenbankverbindung erstellen",
  editDatabaseConnection: "Datenbankverbindung bearbeiten",

  table: "Tabelle",
  databaseConnectionTestError:
    "Es konnte keine Verbindung zur Datenbank hergestellt werden",
  testConnection: "Verbindung testen",
  databaseConnectionTestSuccess: "Testverbindung erfolgreich",
  databaseConnectionTestSuccessMessage:
    "Verbindung zur Datenbank konnte erfolgreich hergestellt werden.",
  connectionStatus: "Verbindungsstatus",
  connectionError: "Verbindungsfehler",
  goToDatabaseManagement: "Zur Datenbankverwaltung",
  moreDetails: "Weitere Details",
  lessDetails: "Weniger Details",
  sort: "Sortieren",
  scopes: "Bereiche",
  host: "Host",
  port: "Port",
  database: "Datenbank",

  redirectingToLogin: "Weiterleitung zur Anmeldeseite...",
  loggingIn: "Anmeldung...",
  errorLoggingIn: "Fehler bei der Anmeldung",
  backToLogin: "Zurück zur Anmeldeseite",
  enabled: "Aktiviert",
  disabled: "Deaktiviert",
  analysis: "Analyse",
  minScore: "Minimum score",
  maxScore: "Maximum score",
  appIsManaged: "Automatisch verwaltet",
  appIsManagedDescription:
    "Automatische verwaltung durch SMX, Änderungen können durch das System überschrieben werden.",
  appIconTooLarge: "Das App Icon ist zu groß. Maximale Größe ist 300Kb.",
  columns: "Spalten",
  update: "Aktualisieren",
  addNote: "Notiz hinzufügen",
  enterNote: "Notiz eingeben...",
  kpiThresholds: "Schwellenwerte",
  note: "Notiz",
  start: "Start",
  end: "Ende",
  deactivateFieldExplanation:
    "Deaktivierte Felder werden nicht weiter ausgewertet und verschwinden aus der Gesamtbewertung. Der Effekt wird erst nach einer erneuten Analyse sichtbar.",
  fieldDeactivated: "Feld deaktiviert",
  fieldDeactivatedDescription:
    "Dieses Feld wurde deaktiviert und wird nicht mehr analysiert",
  downloadExcel: "Excel herunterladen",
  more: "Mehr",
  stop: "Stop",
  downloadDocument: "Dokument herunterladen",
  changes: "Änderungen",
  noteSaved: "Notiz erfolgreich gespeichert",
  schedule: "Zeitplan",
  productionTickets: "Produktionstickets",
  maintenanceTickets: "Wartungstickets",
  deactivated: "Deaktiviert",
  anomaliesDashboard: "Anomalie-Dashboard",
  notStartedYet: "Noch nicht gestartet",
  createReport: "Bericht erstellen",
  addReport: "Bericht hinzufügen",
  twinReportPrefixRequired:
    "Eine Vorlage oder ein Typ müssen ausgewählt werden.",
  twinReportIdFilter: "ID Filter",
  twinReportModifiedFilter: "Geändert am Filter",
  twinReportCreatedFilter: "Erstellt am Filter",
  twinReportDescription: "Beschreibung",
  twinReportCreated: "Erstellt am",
  widgetTitleDescription:
    "Titel des Elements. Falls nicht angegeben wird der Name des Felds verwendet.",
  widgetDescriptionDescription:
    "Beschreibung des Elements und was die Anomalien aussagen. Wird auf dem Element angezeigt.",
  widgetInformationDescription:
    "Zusätzliche Informationen, wird als popover angezeigt und sollte beinhalten was der Anwender tun kann wenn er eine Anomalie sieht.",
  widgetKpiNameDescription:
    "Name des KPI. Falls nicht angegeben wird der Name des KPI verwendet.",
  addReportSheet: "Seite hinzufügen",
  selectAssetOrType:
    "Bestimmt, welche Maschinen, Anlagen oder Geräte im Bericht berücksichtigt werden. Die Auswahl kann über eine Vorlage oder durch Eingabe eines Typs erfolgen. Nutzen Sie das Sternchen * als Platzhalter für beliebige Buchstaben oder Zahlen.",
  selectTicketOrType:
    "Bestimmt, welche Tickets im Bericht berücksichtigt werden. Die Auswahl kann über eine Vorlage oder durch Eingabe eines Typs erfolgen. Nutzen Sie das Sternchen * als Platzhalter für beliebige Buchstaben oder Zahlen.",
  workOrder: "Auftrag",
  workOrders: "Aufträge",
  size: "Größe",
  uploadFailed: "Upload fehlgeschlagen",
  cancelUploads: "Uploads abbrechen",
  cancelUploadsConfirm: "Uploads laufen noch. Abbrechen und schließen?",
  cancelUploadsYes: "Uploads abbrechen",
  cancelUploadsNo: "Weiter hochladen",
  dangerousActions: "Gefährliche Aktionen",
  agentSettings: "Agenteneinstellungen",
  noAgentsAvailable: "Keine Agenten verfügbar",
  products: "Produkte",
  mechanicalAcceptanceReports: "Abnahmeprotokolle Mechanik",
  electricalAcceptanceReports: "Abnahmeprotokolle Elektrik",
  technicalData: "Technische Datenblätter",
  admin: "Admin",
  ticketOrigin: "Übergeordnetes Ticket",
  errorLoadingFiles: "Fehler beim Laden der Dateien",
  uploadFiles: "Dateien hochladen",
  de: "Deutsch",
  en: "Englisch",
  es: "Spanisch",
  discardChanges: "Änderungen verwerfen",
};
